/**
 * Opens the market confirmation popup once the cookie banner is answered.
 *
 *   consent recorded         -> open
 *   no banner in this region -> open
 *   banner still up          -> shut
 *   consent unreadable       -> shut
 *
 * Shut is the safe direction: Shopify's banner is z-index 2000000 against
 * --z-overlay 100, so on mobile it buries the panel rather than overlapping it.
 */
(function () {
  // Permanent. Re-prompting on geo mismatch is the planned replacement.
  var STORAGE_KEY = 'akris_market_confirmation_seen';
  var OVERLAY_ID = 'market-confirmation-popup';

  function hasSeen() {
    try {
      return !!localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return false; // Safari private mode throws on access
    }
  }

  function markSeen() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      // no fallback; panel shows again next visit
    }
  }

  /**
   *   true  -> clear to open
   *   false -> banner still up
   *   null  -> API not loaded
   */
  function consentSettled() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return null;

    // any non-empty value -> answered, declines included.
    // shouldShowBanner() can't carry this alone: still true after an accept.
    if (typeof privacy.currentVisitorConsent === 'function') {
      var consent = privacy.currentVisitorConsent();
      for (var key in consent) {
        if (consent[key]) return true;
      }
    }

    // nothing recorded, but no banner required here either
    if (typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner() === false) {
      return true;
    }

    return false;
  }

  function whenConsentAnswered(callback) {
    var fired = false;

    function finish() {
      if (fired) return;
      fired = true;
      callback();
    }

    document.addEventListener('visitorConsentCollected', finish, { once: true });

    // Cookiebot is domain-licensed: on an uncovered store it loads but never fires.
    ['CookiebotOnAccept', 'CookiebotOnDecline', 'CookiebotOnConsentReady'].forEach(function (name) {
      window.addEventListener(name, finish, { once: true });
    });

    if (consentSettled()) {
      finish();
      return;
    }

    // API loads on demand -> request it, re-check. No timeout: an unanswered
    // banner must never end up with the panel over it.
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        if (consentSettled()) finish();
      });
    }
  }

  /**
   * "<country>:<locale>:<market>" -> two hidden inputs -> Shopify picks the URL.
   * Never build the URL: the subfolder suffix is merchant-typed in admin.
   *
   * The market is stamped on the form for market-switch-guard.js. The country we
   * post is the market's pinned representative, so the guard cannot infer the
   * market from it.
   */
  function bindMarketSelect() {
    var select = document.querySelector('[data-market-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      var form = select.form;
      if (!form || !select.value) return;

      var parts = select.value.split(':');
      var country = form.querySelector('input[name="country_code"]');
      var locale = form.querySelector('input[name="locale_code"]');
      if (!country || !locale || parts.length !== 3) return;

      country.value = parts[0];
      locale.value = parts[1];
      form.dataset.targetMarket = parts[2];

      markSeen(); // submit navigates away
      // requestSubmit, not submit: market-switch-guard.js listens for the
      // submit event to empty the cart. form.submit() fires none.
      form.requestSubmit();
    });
  }

  function init() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    // designMode -> skip. Use #market-confirmation to inspect it.
    if (window.Shopify && window.Shopify.designMode) return;

    overlay.addEventListener('overlay-component:close', markSeen);
    bindMarketSelect();

    if (hasSeen()) return;

    whenConsentAnswered(function () {
      if (hasSeen()) return;
      overlay.open(false); // false -> no hash on an auto-open
    });
  }

  // OverlayComponent inits on load; one frame later its container is in body.
  if (document.readyState === 'complete') {
    requestAnimationFrame(init);
  } else {
    window.addEventListener(
      'load',
      function () {
        requestAnimationFrame(init);
      },
      { once: true }
    );
  }
})();
